import { apiBase, authHeaders } from "./auth";

const GSF_FIELD_LABELS = {
  id_pay_title: "Título",
  id_entity_bank_account: "Conta bancária",
  ds_check_bank: "Banco/Agência",
  nr_check: "Número do Cheque",
  id_cost_center: "Centro de custo",
  id_payment_method: "Meio de pagamento",
  dt_payment: "Data do pagamento",
  vl_payment: "Valor do pagamento",
  vl_interest: "Juros",
  vl_fine: "Multa",
  vl_discount: "Desconto",
  ds_description: "Observação",
};

function formatValidationDetail(detail) {
  if (!Array.isArray(detail) || !detail.length) return null;
  const msgs = detail.map((item) => {
    if (!item || typeof item !== "object") return null;
    if (typeof item.msg === "string" && item.msg !== "Field required") {
      const field = Array.isArray(item.loc) ? item.loc[item.loc.length - 1] : null;
      const label =
        field && typeof field === "string"
          ? GSF_FIELD_LABELS[field] || field
          : null;
      if (label && /required|obrigat/i.test(item.msg)) {
        return `${label} é obrigatório.`;
      }
      return item.msg;
    }
    const field = Array.isArray(item.loc) ? item.loc[item.loc.length - 1] : null;
    if (field && typeof field === "string") {
      const label = GSF_FIELD_LABELS[field] || field;
      if (item.type === "missing" || item.msg === "Field required") {
        return `${label} é obrigatório.`;
      }
    }
    return item.msg || null;
  });
  const clean = msgs.filter(Boolean);
  return clean.length ? clean.join(" ") : null;
}

export function parseGsfError(res, data) {
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && !Array.isArray(detail)) {
    if (typeof detail.message === "string" && detail.message.trim()) {
      return detail.message;
    }
  }
  const formatted = formatValidationDetail(detail);
  if (formatted) return formatted;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return `Erro ${res.status}`;
}

/** Limite do backend (`get_page_request`): page_size ≤ 2000. */
export const GSF_MAX_PAGE_SIZE = 2000;

/** Padrão do seletor «Registros por página» nas listagens. */
export const GSF_DEFAULT_PAGE_SIZE = 10;

/** Lista paginada no backend; retorna só `items` (page_size alto). */
export async function fetchGsfList(path, query = {}) {
  const params = new URLSearchParams();
  params.set("page", String(query.page ?? 1));
  const ps = query.page_size ?? GSF_MAX_PAGE_SIZE;
  params.set(
    "page_size",
    String(Math.min(Number(ps) || GSF_MAX_PAGE_SIZE, GSF_MAX_PAGE_SIZE))
  );
  Object.entries(query).forEach(([k, v]) => {
    if (k === "page" || k === "page_size") return;
    if (v === undefined || v === null || v === "") return;
    if (typeof v === "boolean") {
      params.set(k, v ? "true" : "false");
    } else {
      params.set(k, String(v));
    }
  });
  const qs = params.toString();
  const url = `${apiBase()}${path}?${qs}`;
  const res = await fetch(url, { headers: authHeaders() });
  let data = {};
  try {
    data = await res.json();
  } catch {
    /* ignore */
  }
  if (!res.ok) {
    throw new Error(parseGsfError(res, data));
  }
  return Array.isArray(data.items) ? data.items : [];
}

export async function gsfDelete(path) {
  const res = await fetch(`${apiBase()}${path}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  if (res.status === 204) return;
  let data = {};
  try {
    data = await res.json();
  } catch {
    /* ignore */
  }
  if (!res.ok) {
    throw new Error(parseGsfError(res, data));
  }
}

/** Rótulo de conta bancária da empresa: nome + (número da conta). */
export function formatEntityBankAccountLabel(account, fallbackId = null) {
  if (!account) return fallbackId != null ? `Conta ${fallbackId}` : "Conta";
  const nm = (account.nm_entity_bank_account || account.nm_account || "").trim();
  const nr = (account.ds_account_number || "").trim();
  if (nm && nr) return `${nm} (${nr})`;
  if (nm) return nm;
  if (nr) return nr;
  const id = account.id_entity_bank_account ?? fallbackId;
  return id != null ? `Conta ${id}` : "Conta";
}
